import { Routes } from '@angular/router';
import { ExternalGuard } from './core/auth/guards/auth.guard';
import { LoginComponent } from './core/auth/pages/login/login.component';
import { MonitoringCenterRoutes } from './features/monitoring-center/monitoring-center.routes';
import { RidesBoardRoutes } from './features/rides-board/rides-board-layout/rides-board.routes';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [ExternalGuard],
    component: LoginComponent,
  },
  {
    path: '',
    redirectTo: 'monitoring-center',
    pathMatch: 'full',
  },
  ...MonitoringCenterRoutes,
  ...RidesBoardRoutes,
  {
    path: '**',
    redirectTo: 'auth',
  },
];
